@for (beslutning of skjema().controls; track beslutning.value.beslutningskjema!.id; let indeks = $index) {
  <div class="beslutning-kontainer" [attr.data-beslutning-id]="beslutning.value.beslutningskjema!.id" data-testid="ny-beslutning">
    <div class="beslutning">
      <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
      <beslutning-skjema [skjema]="beslutning.controls.beslutningskjema" [gruppeId]="gruppeId()" [tittelLabel]="'Ny beslutning' | translate"/>
      <button mat-icon-button type="button" (click)="slettNyBeslutning(indeks);" class="slett" data-testid="slett-beslutning-knapp">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
}
